export default "__VITE_ASSET__CXl25v$P__"